import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import Container from 'react-bootstrap/Container';
import CategorySearch from '../../components/Home/CategorySearch/CategorySearch';
import SearchResults from '../../components/search/SearchResults/SearchResults';
import ViewCategory from '../../components/ViewCategory/ViewCategory/ViewCategory';
import messages from '../../locale/messages';
import useQueryResponse from '../../lib/hooks/useQueryResponse';
import getCategory from './getCategory.graphql';
import s from './Categories.css';

const Categories = ({ categoryValue }) => {

  const isNumericCategory = !isNaN(categoryValue);
  const { data, loading } = useQueryResponse({
    query: getCategory,
    skip: !isNumericCategory,
    variables: {
      id: parseInt(categoryValue)
    },
    fetchPolicy: 'network-only',
    ssr: false
  })

  return (
    <div className={'subPageContainer'}>
      <Container>
        {isNumericCategory ? (
          categoryValue !== 'all' && (
            <div>
              <ViewCategory loading={loading} data={data} />
            </div>
          )
        ) : (
          <div>
            <h1 className={s.allCategoryHeading}><FormattedMessage {...messages.allCategories} /></h1>
            <div className={s.allCategoriesSearchInputContainer}>
              <CategorySearch categoryValue={categoryValue} />
            </div>
            <SearchResults categoryValue={categoryValue !== 'all' ? categoryValue : ''} allCategoryloading={loading} />
          </div>
        )}
      </Container>
    </div>
  )
}
export default injectIntl(withStyles(s)(Categories))